$(function () {
  
  $(".pop-up-banner").click(function () {
    $(".pop-up-banner").fadeOut();
  })

  $(".grid-menu").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active")
    $('nav.header__inline-menu').toggleClass("active")
    $("body").toggleClass("no-scroll")
  })

  $("#MainContent").click(function () {
    $('nav.header__inline-menu').removeClass("active")
    $(".grid-menu").removeClass("active")
  })
    
  if($(".product-media").length>0){
    var swiper = new Swiper(".product-media", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  
      var swiperspec = new Swiper(".product-media-spec", {
      navigation: {
        nextEl: ".swiper-button-next-spec",
        prevEl: ".swiper-button-prev-spec",
      },
      });
  }
  
  $(".faq-page .item h4").click(function () {

    $(".faq-page .item").removeClass("active");
    $(this).parent().addClass("active")
  })
  
  
  
  
  $(".product-item").each(function () {
    const $item = $(this);
    const $radios = $item.find("input[type='radio']");
    const $priceDisplay = $item.find(".variant-price");
    const $button = $item.find(".add-to-cart-btn");

    // Initialize price based on the checked variant
    const $checked = $item.find("input[type='radio']:checked");
    if ($checked.length) {
      $priceDisplay.text($checked.data("price"));
    }

    $(".variant-option").not(".variant-disabled").click(function () {
      $(".variant-option").removeClass("active");
      $(this).addClass("active");
      $(this).find("input[type='radio']").prop("checked", true).trigger('change');;

    })


    // $radios.hide();
    // Update price when a variant is selected


    var selectionHTML = $(".model_select_description").html();
    $(".model_select_description").html(selectionHTML.replace("{varient_title}", $(".model_select_txt").html()));

    $radios.on("change", function () {
      const newPrice = $(this).data("price");
      $priceDisplay.text(newPrice);
      $(".model_select_txt").html($(this).data('title'))
    });


    // Handle add to cart + redirect
    $button.on("click", function () {
      const $selected = $item.find("input[type='radio']:checked");
      if (!$selected.length) {
        alert("Please select a model before proceeding.");
        return;
      }

      const variantId = $selected.val();

      
              // STEP 2: Add the selected variant
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: JSON.stringify({ id: variantId, quantity: 1 }),
                dataType: "json",
                contentType: "application/json",
                success: function () {
                  // STEP 3: Redirect to checkout
                  window.location.href = "/cart";
                },
                error: function (xhr, status, error) {
                  console.error("Error adding to cart:", error);
                }
              });
          
        });
      });



})